document.addEventListener('DOMContentLoaded', function() {
  // START function for next orders countdown.
  var stockNumberElement = document.getElementById('stock-number');
  if (stockNumberElement) {
    function updateStockNumber() {
      let currentNumber = parseInt(stockNumberElement.innerText);
      let decreaseAmount = Math.floor(Math.random() * 5) + 1; // Random decrease between 1 and 5
      let newNumber = currentNumber - decreaseAmount;
  
      if (newNumber > 0) {
        stockNumberElement.innerText = newNumber;
      } else {
        // Restart the counter from the starting value
        stockNumberElement.innerText = stockNumberElement.getAttribute('data-order');
      }
    }
  
    // Initial update after 2-3 seconds
    setTimeout(updateStockNumber, Math.floor(Math.random() * 2001) + 2000); // Random time between 2000ms and 4000ms
  
    // Random updates every 5 seconds
    setInterval(function() {
      setTimeout(updateStockNumber, Math.floor(Math.random() * 3001) + 2000); // Random time between 2000ms and 5000ms
    }, 5000);
  }
  // END function for next orders countdown.
});





// Fetch the IDs from the HTML element
var productHandleElement = document.getElementById('redolance-auto-add-product');
var MAIN_PRODUCT_ID;
var GIFT_PRODUCT_ID;

if (productHandleElement) {
    MAIN_PRODUCT_ID =  parseInt(productHandleElement.getAttribute('data-handle'), 10);
    
    // Fetch the product and collection gift attributes
    var productGift = productHandleElement.getAttribute('data-product-gift');
    var collectionGift = productHandleElement.getAttribute('data-collection-gift');
    
    // Prioritize product gift over collection gift
    if (!productGift || productGift === "") {
        GIFT_PRODUCT_ID =  parseInt(collectionGift, 10);
    } else {
        GIFT_PRODUCT_ID =  parseInt(productGift, 10);
    }
}

let isProcessing = false;

// Function to mark main product with redolink.
function addRedoLinkToMain(itemKey, redoLink) {
    return fetch('/cart/change.js', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        properties: {
          _redoLink: redoLink
        },
      }),
    })
    .then(response => response.json())
    .then(data => {
      console.log('Main Product Marked By Redo Link:', data);
      return data;
    })
    .catch(error => {
      console.error('Error Marking Main Product With Redo Link:', error);
    });
}

// Function to add the gift product to the cart
function addGiftProduct(redoLink) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [{
        id: GIFT_PRODUCT_ID,
        quantity: 1,
        properties: {
          _redoLink: redoLink
        },
      }],
    }),
  })
  .then(response => response.json())
  .then(data => {
    console.log('Gift product added to cart');
    return data;
  })
  .catch(error => {
    console.error('Error adding gift product to cart:', error);
  });
}

// Function to remove multiple gift products from the cart
function removeGiftProducts(keys) {
  const removalPromises = keys.map(key => {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: 0,
      }),
    }).then(response => response.json());
  });

  return Promise.all(removalPromises)
    .then(data => {
      console.log('Gift products removed from cart:', data);
      return data;
    })
    .catch(error => {
      console.error('Error removing gift products from cart:', error);
    });
}

// Function to refresh and open the cart drawer
function refreshAndOpenCartDrawer() {
  fetch('/cart?section_id=cart-drawer')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartDrawer = doc.querySelector('#CartDrawer');

      if (newCartDrawer) {
        const cartDrawerElement = document.querySelector('cart-drawer');
        if (cartDrawerElement) {
          cartDrawerElement.querySelector('#CartDrawer').innerHTML = newCartDrawer.innerHTML;

          const isEmpty = !newCartDrawer.querySelector('.cart-item');
          if (isEmpty) {
            cartDrawerElement.classList.add('is-empty');
          } else {
            cartDrawerElement.classList.remove('is-empty');
          }

          cartDrawerElement.open();
          reattachDrawerCloseEvent(cartDrawerElement);
        } else {
          console.error('CartDrawer element not found on the page');
        }
      } else {
        console.error('New CartDrawer not found in the fetched HTML');
      }
    })
    .catch(error => console.error('Error fetching cart drawer:', error));
}

// Function to update the cart icon bubble
function updateCartIconBubble() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartItemCount = cart.item_count;
      const cartIconBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerText = cartItemCount;
      } else {
        console.error('Cart icon bubble element not found on the page');
      }
    })
    .catch(error => console.error('Error fetching cart data:', error));
}

// Function to check for the removal of the main product
function checkForMainProductRemoval() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const redolinkMap = new Map();
      
      cart.items.forEach(item => {
        if (item.properties && item.properties._redoLink) {
          const redolink = item.properties._redoLink;
          if (redolinkMap.has(redolink)) {
            redolinkMap.set(redolink, redolinkMap.get(redolink) + 1);
          } else {
            redolinkMap.set(redolink, 1);
          }
        }
      });

      const uniqueRedolinkKeys = [];
      cart.items.forEach(item => {
        if (item.properties && item.properties._redoLink) {
          const redolink = item.properties._redoLink;
          if (redolinkMap.get(redolink) === 1) {
            uniqueRedolinkKeys.push(item.key);
          }
        }
      });

      return removeGiftProducts(uniqueRedolinkKeys);
    })
    .catch(error => console.error('Error fetching cart data:', error));
}

// Function to reattach the close event listener
function reattachDrawerCloseEvent(cartDrawerElement) {
  const overlay = document.getElementById('CartDrawer-Overlay');
  if (overlay) {
    overlay.addEventListener('click', () => {
      cartDrawerElement.close();
    });
  }
}

// Function to generate unique redo value
function generateRedoValue() {
  const randomNum = Math.floor(Math.random() * 1000000);
  const timestamp = Date.now();
  return `redo_${randomNum}_${timestamp}`;
}

// Override the fetch method to listen for specific requests
(function() {
  console.log('Initializing fetch override for adding gift product and refreshing cart drawer');

  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      if (response.url.includes('/cart/add')) {
        response.clone().json().then(data => {
          const mainProductAdded = (data.items && data.items.find(item => item.product_id === MAIN_PRODUCT_ID && !item.properties?.redolink)) || 
                                   (data.product_id === MAIN_PRODUCT_ID && !data.properties?.redolink && { key: data.key });
          const mainProductKey = mainProductAdded ? mainProductAdded.key : null;
          if (mainProductKey) {
            const redoLink = generateRedoValue();
            isProcessing = true;
            addRedoLinkToMain(mainProductKey, redoLink).then(() => {
              addGiftProduct(redoLink).then(() => {
                isProcessing = false;
                refreshAndOpenCartDrawer();
                updateCartIconBubble();
              });
            });
          }
        }).catch(error => {
          console.error('Error parsing response JSON:', error);
        });
      } else if (response.url.includes('/cart/change')) {
        response.clone().json()
          .then(() => {
            if (!isProcessing) {
              return checkForMainProductRemoval(); 
            }
          })
          .then(() => {
            refreshAndOpenCartDrawer();
            updateCartIconBubble();
          })
          .catch(error => {
            console.error('Error parsing response JSON or in checkForMainProductRemoval:', error);
          });
      }
      return response;
    }).catch(error => {
      console.error('Error in fetch response:', error);
    });
  };
})();






// Do something whenever Cart is Requested.
const originalFetch = window.fetch;
window.fetch = function(...args) {
  return originalFetch.apply(this, args).then(response => {
    // Check if the URL contains '/cart'
    if (args[0].includes('/cart')) {
      // Call the custom function to add the class
      response.clone().text().then(() => {
        addGiftItemClass();
        //addOfferItemClass()
      });
    }
    return response;
  });
};

// Function to add the class to items with 'Free Gift' custom data.
function addGiftItemClass() {
  document.querySelectorAll('.cart-item').forEach(item => {
    
    // Find the final price element within the current cart item
    const finalPriceElement = item.querySelector('.cart-item__final-price, .price.price--end');
  
    if (finalPriceElement) {
      // Extract the text content and remove any currency symbols and whitespace
      const priceText = finalPriceElement.textContent.trim();
      const numericPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      if (numericPrice === 0.00) {
        item.classList.add('gift-item');
        finalPriceElement.classList.add('redo-all-hide');
      }
    }  
  }); 
  // Make all links in the gift item not clickable
  document.querySelectorAll('.gift-item a').forEach(link => {
    link.style.pointerEvents = 'none';
  });
}



document.addEventListener('DOMContentLoaded', function() {
    addGiftItemClass();
});